webpackJsonp([129519670211406],{

/***/ 1378:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/sp2.dc5a9571.png";

/***/ }),

/***/ 3214:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/sprobg.1ad90d2b.jpg";

/***/ }),

/***/ 1380:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/sprologo.e612e808.png";

/***/ }),

/***/ 1730:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactHelmet = __webpack_require__(8);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	var _withStyles = __webpack_require__(3);
	
	var _withStyles2 = _interopRequireDefault(_withStyles);
	
	var _siteConfig = __webpack_require__(7);
	
	var _siteConfig2 = _interopRequireDefault(_siteConfig);
	
	var _Container = __webpack_require__(5);
	
	var _Container2 = _interopRequireDefault(_Container);
	
	var _BgSectionExternal = __webpack_require__(33);
	
	var _BgSectionExternal2 = _interopRequireDefault(_BgSectionExternal);
	
	var _sprobg = __webpack_require__(3214);
	
	var _sprobg2 = _interopRequireDefault(_sprobg);
	
	var _fadebg = __webpack_require__(42);
	
	var _fadebg2 = _interopRequireDefault(_fadebg);
	
	var _sprologo = __webpack_require__(1380);
	
	var _sprologo2 = _interopRequireDefault(_sprologo);
	
	var _quote = __webpack_require__(51);
	
	var _quote2 = _interopRequireDefault(_quote);
	
	var _sp = __webpack_require__(64);
	
	var _sp2 = _interopRequireDefault(_sp);
	
	var _sp3 = __webpack_require__(1378);
	
	var _sp4 = _interopRequireDefault(_sp3);
	
	var _sp5 = __webpack_require__(92);
	
	var _sp6 = _interopRequireDefault(_sp5);
	
	var _sp7 = __webpack_require__(93);
	
	var _sp8 = _interopRequireDefault(_sp7);
	
	var _glance = __webpack_require__(49);
	
	var _glance2 = _interopRequireDefault(_glance);
	
	var _glance3 = __webpack_require__(50);
	
	var _glance4 = _interopRequireDefault(_glance3);
	
	var _SEO = __webpack_require__(6);
	
	var _SEO2 = _interopRequireDefault(_SEO);
	
	var _FormProduct = __webpack_require__(94);
	
	var _FormProduct2 = _interopRequireDefault(_FormProduct);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Socialpro = function Socialpro(_ref) {
	  var children = _ref.children,
	      classes = _ref.classes,
	      data = _ref.data,
	      tags = _ref.tags;
	
	  var postNode = {
	    title: "Elevate Social ProTM - " + _siteConfig2.default.siteTitle
	  };
	
	  return _react2.default.createElement(
	    "div",
	    { className: classes.root },
	    _react2.default.createElement(
	      _reactHelmet2.default,
	      null,
	      _react2.default.createElement(
	        "title",
	        null,
	        "Elevate Social ProTM - " + _siteConfig2.default.siteTitle
	      )
	    ),
	    _react2.default.createElement(_SEO2.default, { postNode: postNode, pagePath: "Socialpro", customTitle: true }),
	    _react2.default.createElement(
	      "div",
	      { style: { backgroundImage: "url(" + _sprobg2.default + ")", backgroundSize: "cover", backgroundPosition: "centerTop" } },
	      _react2.default.createElement(
	        _Container2.default,
	        null,
	        _react2.default.createElement(
	          "div",
	          { className: classes.top, style: { paddingBottom: "30px", paddingRight: "35px", paddingLeft: "35px", paddingTop: "75px" } },
	          _react2.default.createElement(
	            "div",
	            { className: classes.centerHeading },
	            _react2.default.createElement("img", { src: _sprologo2.default, width: "100%", style: { paddingBottom: "18px", paddingTop: "20px", maxWidth: "350px" } }),
	            _react2.default.createElement(
	              "div",
	              { className: classes.heading, style: { color: "#ffffff" } },
	              "The Power of SOCIAL MEDIA"
	            ),
	            _react2.default.createElement(
	              "div",
	              { className: classes.subtext, style: { color: "#f7f7f7", fontSize: "18px" } },
	              "Turn your social media from a toy into a tool."
	            )
	          )
	        ),
	        _react2.default.createElement(
	          "div",
	          { className: classes.top, style: { paddingBottom: "50px" } },
	          _react2.default.createElement(
	            "div",
	            { className: classes.column2, style: { textAlign: "center", paddingBottom: "10px" } },
	            _react2.default.createElement(
	              "a",
	              { href: "#demo", className: classes.buttonLink },
	              "Request Demo"
	            )
	          ),
	          _react2.default.createElement(
	            "div",
	            { className: classes.column2, style: { textAlign: "center", paddingBottom: "10px" } },
	            _react2.default.createElement(
	              "a",
	              { target: "_blank", href: "/compare_products", className: classes.buttonLink },
	              "Compare Products"
	            )
	          )
	        )
	      )
	    ),
	    _react2.default.createElement(
	      "div",
	      { style: { paddingTop: "58px" } },
	      _react2.default.createElement(
	        _Container2.default,
	        null,
	        _react2.default.createElement(
	          "div",
	          { style: { textAlign: "center", paddingRight: "35px", paddingLeft: "35px", paddingBottom: "35px" } },
	          _react2.default.createElement(
	            "div",
	            { className: classes.Heading2 },
	            "Key Highlights"
	          ),
	          _react2.default.createElement(
	            "div",
	            { className: classes.subtext },
	            "Automate your social media marketing so you can focus on what matters the most...",
	            _react2.default.createElement("br", null),
	            "growing your sphere & selling more homes, faster..."
	          )
	        )
	      )
	    ),
	    _react2.default.createElement(
	      "div",
	      { style: { backgroundImage: "url(" + _fadebg2.default + ")", backgroundSize: "cover", backgroundPosition: "centerBottom" } },
	      _react2.default.createElement(
	        _Container2.default,
	        null,
	        _react2.default.createElement(
	          "div",
	          { className: classes.top, style: { textAlign: "center" } },
	          _react2.default.createElement(
	            "div",
	            { className: classes.column3, style: { textAlign: "center", paddingTop: "20px" } },
	            _react2.default.createElement(
	              "div",
	              { className: classes.subtext2 },
	              "Customized social branding on Facebook, Twitter, LinkedIn & YouTube"
	            ),
	            _react2.default.createElement(
	              "div",
	              { style: { textAlign: "center" } },
	              _react2.default.createElement("img", { src: _sp2.default, width: "100%", style: { paddingTop: "25px", maxWidth: "320px" } })
	            )
	          ),
	          _react2.default.createElement(
	            "div",
	            { className: classes.column3, style: { textAlign: "center", paddingTop: "20px" } },
	            _react2.default.createElement(
	              "div",
	              { className: classes.subtext2 },
	              "Relevant, life-style content",
	              _react2.default.createElement("br", null),
	              "posted weekly"
	            ),
	            _react2.default.createElement(
	              "div",
	              { style: { textAlign: "center" } },
	              _react2.default.createElement("img", { src: _sp4.default, width: "100%", style: { paddingTop: "25px", maxWidth: "320px" } })
	            )
	          ),
	          _react2.default.createElement(
	            "div",
	            { className: classes.column3, style: { textAlign: "center", paddingTop: "20px" } },
	            _react2.default.createElement(
	              "div",
	              { className: classes.subtext2 },
	              "Automated posts of new listings",
	              _react2.default.createElement("br", null),
	              "& listing updates"
	            ),
	            _react2.default.createElement(
	              "div",
	              { style: { textAlign: "center" } },
	              _react2.default.createElement("img", { src: _sp6.default, width: "100%", style: { paddingTop: "25px", maxWidth: "320px" } })
	            )
	          )
	        )
	      )
	    ),
	    _react2.default.createElement(
	      "div",
	      { style: { paddingTop: "40px", backgroundImage: "url(" + _fadebg2.default + ")", backgroundSize: "cover", backgroundPosition: "centerBottom" } },
	      _react2.default.createElement(
	        _Container2.default,
	        null,
	        _react2.default.createElement(
	          "div",
	          { className: classes.top, style: { textAlign: "center" } },
	          _react2.default.createElement(
	            "div",
	            { className: classes.column2, style: { textAlign: "center", paddingTop: "20px" } },
	            _react2.default.createElement(
	              "div",
	              { className: classes.subtext2 },
	              "Automated creation of",
	              _react2.default.createElement("br", null),
	              "YouTube video tours"
	            ),
	            _react2.default.createElement(
	              "div",
	              { width: "100%", style: { textAlign: "center", maxWidth: "400px", marginLeft: "auto", marginRight: "auto", paddingTop: "25px" } },
	              _react2.default.createElement(
	                "div",
	                { style: { textAlign: "center" }, className: classes.videoEmbed },
	                _react2.default.createElement("iframe", { className: classes.videoContainer, src: "https://www.youtube.com/embed/CwXlC7Xuojs",
	                  frameborder: "0", allow: "accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture", allowfullscreen: true })
	              )
	            )
	          ),
	          _react2.default.createElement(
	            "div",
	            { className: classes.column2, style: { textAlign: "center", paddingTop: "20px" } },
	            _react2.default.createElement(
	              "div",
	              { className: classes.subtext2 },
	              "Content-rich consumer",
	              _react2.default.createElement("br", null),
	              "blog with weekly posts"
	            ),
	            _react2.default.createElement(
	              "div",
	              { style: { textAlign: "center" } },
	              _react2.default.createElement("img", { src: _sp8.default, width: "100%", style: { paddingTop: "25px", maxWidth: "320px" } })
	            )
	          ),
	          _react2.default.createElement("a", { id: "demo" })
	        )
	      )
	    ),
	    _react2.default.createElement(
	      "div",
	      { style: { backgroundColor: "#ffffff", paddingBottom: "60px", textAlign: "center", paddingRight: "30px", paddingLeft: "30px" } },
	      _react2.default.createElement(
	        "h1",
	        { className: classes.Heading2, style: { paddingTop: "70px" } },
	        "Take a Tour of Elevate Today"
	      ),
	      _react2.default.createElement(
	        "h2",
	        { className: classes.subtext },
	        "Schedule 15-minutes with an Elevate Success Coach to explore Elevate\u2019s marketing power."
	      ),
	      _react2.default.createElement(_FormProduct2.default, {
	        subject: "Social Pro Product Lead",
	        listid: "107379",
	        webhook: "b1452e08-f398-11ea-9d14-bc764e046a9d",
	        leadsource: "tryelevate.com:socialpro" })
	    ),
	    _react2.default.createElement(
	      "div",
	      { style: { paddingTop: "50px", paddingBottom: "50px", backgroundColor: "#f7f7f7" } },
	      _react2.default.createElement(
	        "div",
	        { style: { textAlign: "center", paddingRight: "35px", paddingLeft: "35px", paddingBottom: "25px" } },
	        _react2.default.createElement(
	          "div",
	          { className: classes.Heading2 },
	          "Happy Customers"
	        ),
	        _react2.default.createElement(
	          "div",
	          { className: classes.subtext },
	          "What the world needs now is love, love, love."
	        )
	      ),
	      _react2.default.createElement(
	        _Container2.default,
	        null,
	        _react2.default.createElement(
	          "div",
	          { className: classes.flexContainer },
	          _react2.default.createElement(
	            "div",
	            { className: classes.flexItem2, style: { padding: "30px", textAlign: "center" } },
	            _react2.default.createElement("img", { src: _quote2.default, width: "80", style: { paddingBottom: "15px" } }),
	            _react2.default.createElement(
	              "div",
	              { className: classes.subtext },
	              "\u201CI always struggled with creating & managing my social media until Elevate.  Now I look like a pro!\u201D",
	              _react2.default.createElement("br", null),
	              _react2.default.createElement("br", null),
	              _react2.default.createElement(
	                "div",
	                { className: classes.Heading3 },
	                "Jennifer M."
	              ),
	              "San Clemente, CA"
	            )
	          ),
	          _react2.default.createElement(
	            "div",
	            { className: classes.flexItem2, style: { padding: "30px", textAlign: "center" } },
	            _react2.default.createElement("img", { src: _quote2.default, width: "80", style: { paddingBottom: "15px" } }),
	            _react2.default.createElement(
	              "div",
	              { className: classes.subtext },
	              "\u201CI\u2019ve had so many complements",
	              _react2.default.createElement("br", null),
	              "on my blog articles, and I don\u2019t have",
	              _react2.default.createElement("br", null),
	              "to lift a finger.\u201D",
	              _react2.default.createElement("br", null),
	              _react2.default.createElement("br", null),
	              _react2.default.createElement(
	                "div",
	                { className: classes.Heading3 },
	                "Michael K."
	              ),
	              "Tampa, FL"
	            )
	          ),
	          _react2.default.createElement(
	            "div",
	            { className: classes.flexItem2, style: { padding: "30px", textAlign: "center" } },
	            _react2.default.createElement("img", { src: _quote2.default, width: "80", style: { paddingBottom: "15px" } }),
	            _react2.default.createElement(
	              "div",
	              { className: classes.subtext },
	              "\u201CElevate has saved me hours of frustration & time with my online marketing.  I love the automation.\u201D",
	              _react2.default.createElement("br", null),
	              _react2.default.createElement("br", null),
	              _react2.default.createElement(
	                "div",
	                { className: classes.Heading3 },
	                "Mary Ann B."
	              ),
	              "Arlington, TX"
	            )
	          )
	        )
	      )
	    )
	  );
	};
	
	exports.default = (0, _withStyles2.default)(function (theme) {
	  var _flexContainer, _flexItem, _flexItem2, _flexItem3;
	
	  return {
	    root: {
	      display: "flex",
	      flexDirection: "column",
	      width: "100%",
	      margin: "auto"
	    },
	
	    top: {
	      display: "flex",
	      flexWrap: "wrap",
	      alignItems: "top"
	    },
	
	    heading: {
	      fontSize: "33px",
	      fontWeight: "700",
	      lineHeight: "40px",
	      letterSpacing: ".14px",
	      color: "#52B1AD",
	      marginBottom: "12px"
	    },
	
	    subtext: {
	      fontSize: "16px",
	      fontWeight: "300",
	      lineHeight: "24px",
	      color: "#777777"
	    },
	
	    subtext2: {
	      fontSize: "16px",
	      fontWeight: "700",
	      lineHeight: "24px",
	      color: "#777777"
	    },
	
	    column2: {
	      width: "530px",
	      maxWidth: "100%",
	      paddingRight: "20px",
	      paddingLeft: "20px",
	      verticalAlign: "top"
	    },
	
	    column3: {
	      width: "350px",
	      maxWidth: "100%",
	      paddingRight: "10px",
	      paddingLeft: "10px",
	      verticalAlign: "top"
	    },
	
	    bold: {
	      fontWeight: "700"
	    },
	
	    centerHeading: {
	      alignItems: "center",
	      width: "100%",
	      textAlign: "center"
	    },
	
	    Heading2: {
	      fontSize: "28px",
	      paddingBottom: "20px",
	      fontWeight: "700",
	      lineHeight: "34px",
	      color: "#52B1AD",
	      letterSpacing: ".14px"
	    },
	
	    Heading3: {
	      fontSize: "20px",
	      paddingBottom: "5px",
	      fontWeight: "700",
	      lineHeight: "26px",
	      color: "#52B1AD",
	      letterSpacing: ".14px"
	    },
	
	    landingHeaderStyle: {
	      textAlign: "center"
	    },
	
	    buttonLink: {
	      minWidth: "250px",
	      maxWidth: "250px",
	      alignContent: "center",
	      justifyContent: "center",
	      fontSize: "14px",
	      fontWeight: "700",
	      display: "block",
	      letterSpacing: ".25px",
	      backgroundColor: "#52B1AD",
	      color: "#FFF",
	      textDecoration: "none",
	      padding: "16px",
	      borderRadius: "4px",
	      margin: "16px auto",
	      marginBottom: "10px"
	    },
	
	    flexContainer: (_flexContainer = {
	      padding: "0",
	      margin: '0',
	
	      display: "-webkit-box"
	    }, _flexContainer["display"] = "-moz-box", _flexContainer["display"] = "-ms-flexbox", _flexContainer["display"] = "-webkit-flex", _flexContainer["display"] = "flex", _flexContainer.flexWrap = "wrap", _flexContainer),
	    flexItem: (_flexItem = {
	      maxWidth: "100%",
	      width: "100%",
	      paddingRight: "0px",
	      paddingBottom: "25px"
	
	    }, _flexItem[theme.breakpoints[900]] = {
	      maxWidth: "50%",
	      width: "50%",
	      paddingRight: "20px",
	      paddingBottom: "0px"
	    }, _flexItem),
	
	    flexItem2: (_flexItem2 = {
	      maxWidth: "100%",
	      width: "100%",
	      paddingRight: "0px",
	      paddingBottom: "25px"
	
	    }, _flexItem2[theme.breakpoints[900]] = {
	      maxWidth: "33%",
	      width: "33%",
	      paddingRight: "20px",
	      paddingBottom: "0px"
	    }, _flexItem2),
	
	    flexItem3: (_flexItem3 = {
	      maxWidth: "100%",
	      width: "100%",
	      paddingRight: "0px",
	      paddingBottom: "25px"
	
	    }, _flexItem3[theme.breakpoints[900]] = {
	      maxWidth: "40%",
	      width: "40%",
	      paddingRight: "20px",
	      paddingBottom: "0px"
	    }, _flexItem3),
	    videoEmbed: {
	      position: "relative",
	      paddingBottom: "56.25%",
	      paddingTop: "30px",
	      height: "0",
	      overflow: "hidden"
	
	    },
	    videoContainer: {
	      position: "absolute",
	      top: "0",
	      left: "0",
	      width: "100%",
	      height: "100%"
	
	    }
	  };
	})(Socialpro);
	module.exports = exports["default"];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-socialpro-js-f26a40122fb5e43bc930.js